import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RegistrationSummaryEmailService } from './registration-summary-email.service';

@NgModule({
  providers: [RegistrationSummaryEmailService, provideHttpClient(withInterceptorsFromDi())],
})
export class RegistrationSummaryEmailModule {}
